export default __webpack_public_path__ + "static/pia@2x-309ea158db01aeb3547565f9d61d01e5.png";